import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import { FaRegListAlt } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import { BsFillCheckCircleFill } from "react-icons/bs";
import Table from "../../components/UserDashboard/Table";
import { MdAssignment, MdCancel } from "react-icons/md";
import Promos from "../../components/UserDashboard/Promos";
import { Empty } from "../../components/UserDashboard/Notifications/Error";
import { useDispatch, useSelector } from "react-redux";
// import { getAllOrdersAction } from "../../Redux/Actions/OrderAction";
import toast from "react-hot-toast";
import orderData from "./data";
import BigLoader from "../UserDashboard/Notifications/BigLoader";
import bookingApi from "../../api/booking/BookingApi";
import Loading from "../../Util/Loading";
import { HiOutlineClock } from "react-icons/hi";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { MdCalendarToday } from "react-icons/md";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";

function Dashboard() {
  const { user } = useSelector((state) => state.user || {});
  const dispatch = useDispatch();

  const [booking, setBooking] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const getAllBookings = async () => {
    try {
      const { response, err } = await bookingApi.getAllBookings();

      if (response && response.data) {
        setBooking(response.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // Don't show toast here
        return;
      }
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return; // ✅ Skip fetching if user is missing

      setIsLoading(true);
      await Promise.all([getAllBookings()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!user) {
      dispatch(setAuthModalOpen(true));
    }
  }, [user, dispatch]);

  if (!user) return null;

  {
    console.log({ booking });
  }

  const loading = false;
  const error = false;
  const orders = booking?.booking;
  const total = booking?.total;
  // const pending = orderData?.pending;
  const completed = booking?.booked;
  const cancelled = booking?.cancelled;

  console.log({ orders });

  const now = new Date();
  const completedBookings =
    orders?.filter((booking) => {
      return (
        booking?.booking?.status === "booked" &&
        new Date(booking.selectedDateTime) < now
      );
    }) || [];

  // boxes
  const Status = [
    {
      bg: "bg-yellow-100",
      icon: MdAssignment,
      color: "text-yellow-500",
      title: "Total Bookings",
      total: total ? total : 0,
    },
    {
      bg: "bg-green-100",
      icon: MdCalendarToday,
      color: "text-green-500",
      title: "Upcoming Bookings",
      total:
        orders?.filter(
          (b) =>
            b?.booking?.status === "booked" &&
            new Date(b.selectedDateTime) >= now
        ).length || 0,
    },
    {
      bg: "bg-red-100",
      icon: MdCancel,
      color: "text-red-500",
      title: "Cancelled Bookings",
      total: cancelled ? cancelled : 0,
    },
    {
      bg: "bg-gray-400",
      icon: AiOutlineCheckCircle,
      color: "text-gray-600",
      title: "Completed Bookings",
      total: completedBookings.length,
    },
  ];

  if (isLoading) {
    return <Loading />;
  }

  return (
    <SideBar>
      {loading ? (
        <div className="flex-colo h-96">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <div className="md:block hidden">
            <Promos />
          </div>
          <h2 className="text-xl font-bold">Dashboard</h2>
          <div className="grid lg:grid-cols-4 2xl:grid-cols-4 sm:grid-cols-2 gap-3">
            {Status.map((status, i) => (
              <div
                key={i}
                className="p-4 rounded border border-border grid grid-cols-4 gap-2"
              >
                <div
                  className={`rounded-full col-span-1 text-lg w-12 h-12 flex-colo ${status.bg} ${status.color}`}
                >
                  <status.icon />
                </div>
                <div className=" col-span-3">
                  <h2 className="text-sm">{status.title}</h2>
                  <p className="font-bold mt-2">{status.total}</p>
                </div>
              </div>
            ))}
          </div>

          {user &&
            (orders?.length === 0 ? (
              <div className="flex-colo h-96">
                <Empty text={"No order found"} />
              </div>
            ) : (
              // <Table datas={orders} dashboard={true} />
              <Table
                datas={Array.isArray(orders) ? orders : []}
                dashboard={true}
              />
            ))}
        </div>
      )}
    </SideBar>
  );
}

export default Dashboard;
